// extracted by mini-css-extract-plugin
module.exports = {"sitePrompt":"CompletePurchase_sitePrompt__8ZfPI","terms":"CompletePurchase_terms__3opR0"};